import { AbsoluteFlexColumnAnimated } from 'navigation-ui/modal-screen'
import React, { } from 'react'

import { ReactFC } from 'types'


const ModalScreen: ReactFC = ({ children }) => (
  <AbsoluteFlexColumnAnimated>
    {React.Children.only(children)}
  </AbsoluteFlexColumnAnimated>
)

export default ModalScreen
